import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, SectionHeader } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/inquiries`, form);
      setSent(true);
      toast.success("Inquiry received. We respond to every message directly.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const field =
    "w-full bg-transparent border border-white/[0.12] px-5 py-4 text-[#f2f0eb] placeholder:text-[#555] text-sm transition-colors duration-300";

  return (
    <section id="contact" className="py-24 md:py-36 bg-[#070707] border-t border-white/[0.06]" data-testid="contact-section">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <SectionHeader number="03" title="Contact" testId="contact" />
        <div className="grid lg:grid-cols-12 gap-16">
          <Reveal className="lg:col-span-5">
            <h3 className="font-display font-light text-3xl md:text-5xl tracking-tight leading-tight" data-testid="contact-headline">
              Begin the<br />
              <span className="text-[#e65c00]">conversation.</span>
            </h3>
            <p className="mt-8 text-[#8a8a8a] leading-relaxed max-w-md">
              Whether you are an owner considering a transition, a founder
              seeking a long-term partner, or an allocator evaluating the
              firm — we review every inquiry and respond directly.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-7">
            {sent ? (
              <div className="border border-[#0a4d3c] bg-[#0a4d3c]/20 p-12" data-testid="contact-success-message">
                <p className="font-display text-2xl text-[#f2f0eb] mb-3">Thank you.</p>
                <p className="text-[#a8a8a8]">Your inquiry has been received. We will be in touch shortly.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="flex flex-col gap-5" data-testid="contact-form">
                <div className="grid md:grid-cols-2 gap-5">
                  <input
                    required
                    placeholder="Name"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className={field}
                    data-testid="contact-name-input"
                  />
                  <input
                    required
                    type="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className={field}
                    data-testid="contact-email-input"
                  />
                </div>
                <textarea
                  required
                  rows={6}
                  placeholder="Message"
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  className={`${field} resize-none`}
                  data-testid="contact-message-input"
                />
                <button
                  type="submit"
                  disabled={sending}
                  className="w-full sm:w-auto sm:self-start font-mono-tech text-[11px] tracking-[0.25em] uppercase px-10 py-4 bg-[#e65c00] text-black font-medium hover:bg-[#ff7a1a] transition-colors duration-300 disabled:opacity-50"
                  data-testid="contact-submit-button"
                >
                  {sending ? "Sending..." : "Submit →"}
                </button>
              </form>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
